"use strict";

require("core-js/modules/es.array.iterator");

var curry = require("../Strict/curry.js");

module.exports = curry(function* appendL(a, iter) {
  yield* iter;
  yield a;
});